export default __webpack_public_path__ + "src/docs/packages/marataba-conservation-camps.pdf";